import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {WarehouseProjectionDto} from "../../api/cms";

interface CmsStorageOption {
    value: string
    label: string
}

function toOption(dto: WarehouseProjectionDto): CmsStorageOption {
    return {
        value: dto.warehouseId,
        label: `${dto.name} (${dto.warehouseNumber})`
    }
}

class CmsStorageStore {
    private get initialized(): boolean {
        return this._initialized;
    }

    private set initialized(value: boolean) {
        this._initialized = value;
    }

    get warehouseOptions(): CmsStorageOption[] {
        return this._warehouseOptions;
    }

    private set warehouseOptions(value: CmsStorageOption[]) {
        this._warehouseOptions = value;
    }

    private _initialized: boolean = false
    private _warehouseOptions: CmsStorageOption[] = []

    constructor() {
        makeAutoObservable(this)
    }

    init() {
        if (this.initialized) {
            return
        }
        this.initialized = true
        this.load().finally()
    }

    async load() {
        const result = await catchApi(async () => await api.cms.api.listCustomerWarehouses())
        const data = result?.data || []
        this.warehouseOptions = data.map(toOption)
    }
}

const cmsStorageStore = new CmsStorageStore()

export {
    cmsStorageStore
}
